import CalendarService from "@/services/CalendarService";

const state = {
  calendar: [],
};

const getters = {
  getCalendar(state) {
    return state.calendar;
  },
};
const actions = {
  async loadCalendar({ commit }, payload) {
    const { start, end } = payload;
    const response = await CalendarService.getCalendar(start, end);
    const calendar = response.data.results || [];

    commit("setCalendar", calendar);
  },
};

const mutations = {
  setCalendar(state, calendar) {
    state.calendar = calendar;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
